import http from '../../http/base';
import { API_PATHS } from '../../http/configs';

export default {
    getIsGroupMembershipAddedToPartner: partnerId =>
        http.get(API_PATHS.isGroupMembershipAddedToPartner, { params: { partnerId } }),
};
